import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { selectDataByKeyOrDefault } from 'src/storage/general.selectors';

@Component({
  selector: 'app-retoma-duplicado',
  standalone:false,
  templateUrl: './retoma-duplicado.component.html',
  styleUrl: './retoma-duplicado.component.scss'
})
export class RetomaDuplicadoComponent implements OnInit {

  private subscription = new Subscription();
  private store = inject(Store);
  urlRetoma: string = '';

  ngOnInit(): void {
    this.subscription.add(
      this.store.select(selectDataByKeyOrDefault('leadDuplicatedData')).subscribe(data => {
        console.log('Datos duplicados:', data);
        if(data){
          this.urlRetoma = data.UrlRetoma || '';
        }
      })
    );
  }


  handleClick(): void {
    if(this.urlRetoma !== ''){
      window.location.href = this.urlRetoma;
    }
  }
}
